import { fetchAuthSession } from "@aws-amplify/auth";
import awsconfig from "./../aws-exports";

class SocketioService {
  socket;
  constructor() {}

  async setupSocketConnection() {
    this.socket = null;
    let access_token = null;
    await fetchAuthSession()
      .then((session) => {
        access_token = session.tokens?.accessToken?.toString();
        this.overlay = false;

        this.socket = new WebSocket(
          `${awsconfig.API.endpoints[1].endpoint}/?access_token=${access_token}`
        );

        this.socket.onopen = function (event) {
        };
      })
      .catch(() => {
        this.overlay = false;
      });
  }

  getSocket() {
    return this.socket;
  }
}

export default new SocketioService();
